import { NgModule } from '@angular/core';

import { TruncateComponent } from './truncate.component';

@NgModule({
  imports: [],
  declarations: [TruncateComponent],
  exports: [TruncateComponent],
})
export class TruncateModule {}
export { TruncateComponent } from './truncate.component';
